<template>
  <v-container v-if="isLoading || isCoreLoading" class="pa-0" fill-height>
    <v-row align="center" justify="center">
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="printLoading"
        color="blue">{{ printLoading }}%</v-progress-circular>
    </v-row>
  </v-container>
  <div v-else class="pm-container">
    <iframe :src="printSource" :style="printViewerHeight">
      <p>このデバイスではPDFのプレビュー機能をお使いになれません。</p>
    </iframe>
  </div>
</template>
<script>
// import template from '@/assets/templates/application'
import template from '@/assets/templates/profile'
export default {
  name: 'pdfMakerPane',
  props: [
    'status'
  ],
  data () {
    return {
      config: {
        status: {
          loading: true
        }
      },
      form: {
        backgrounds: {}
      },
      store: {
        document: {},
        src: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this.store, 'src', '')
      this.update()      
    },
    update: function () {
      this.$set(this.config.status, 'loading', 0)
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}about/get/backgrounds`, {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': token
          },
          onUploadProgress: (e) => {
            this.$set(this.config.status, 'loading', Math.ceil(e.loaded / e.total * 50))
          }
        }).then(res => {
          if (res.data && res.data.success) {
            const docData = template.publish({ office: this.$store.getters['author/get']('belong'), backgrounds: res.data.data })
            this.$set(this.form, 'backgrounds', res.data.data)
            this.axios.post(`${this.$url.api}apply/doc/review`, {
              data: docData
            }, {
              headers: {
                'firebase-token': token
              },
              onUploadProgress: (e) => {
                this.$set(this.config.status, 'loading', 50 + Math.ceil(e.loaded / e.total * 50))
              }
            }).then(res => {
              if (res.data && res.data.success) {
                this.$set(this.config.status, 'loading', false)
                this.$set(this.store, 'src', res.data.data)
              }
            })
          }
        })
      })
    },
    publish: function () {
      if (this.form.backgrounds) {
        const cid = this.$route.params.id
        const docData = template.publish(this.form)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}about/doc/publish/${cid}`, {
            doc: docData
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$store.dispatch('notifier/addSSuccess', {
                title: '補足情報シート',
                message: '発行が完了しました。'
              })
              this.$emit('done')
            } else if (
              res.data &&
              res.data.data &&
              res.data.data.response &&
              res.data.data.response.body &&
              res.data.data.response.body.code
            ) {
              let code = res.data.data.response.body.code
              let err = this.$error.box.file.upload[code] ? this.$error.box.file.upload[code] : ''
              if (err) {
                this.$store.dispatch('notifier/addAlert', {
                  title: '発行失敗',
                  message: err
                })
                this.$emit('error')
              }
            }
          }).catch(err => {
            console.log(err)
          })
        })
      }
    }
  },
  computed: {
    isLoading () {
      return Number.isFinite(this.config.status.loading)
    },
    isCoreLoading () {
      return this.$props.status && Number.isFinite(this.$props.status.loading)
    },
    printSource () {
      return this.store.src
    },
    printViewerHeight () {
      return `min-height:${window.innerHeight - 110}px;`
    },
    printLoading () {
      if (Number.isFinite(this.config.status.loading)) {
        return this.config.status.loading
      } else if (this.$props.status && Number.isFinite(this.config.status.loading)) {
        return this.$props.status.loading
      } else {
        return ''
      }
    },
    getFormItem () {
      return this.$props.form ? this.$props.form : {}
    }
  }
}
</script>
